import * as api from "../api/menu.api";

export const getMenu = () => {
  return api.getMenu().then((response) => response.data);
};
